// theme.js — Shared theme colors and density settings
// Used by all MarketWatch components

export function getTheme(isDark) {
  return {
    bg: isDark ? '#0f1117' : '#f8f9fb',
    bgCard: isDark ? '#181b27' : '#ffffff',
    bgRow: isDark ? 'transparent' : 'transparent',
    bgRowHover: isDark ? '#1e2130' : '#f0f4ff',
    bgInput: isDark ? '#1a1d2a' : '#f3f4f6',
    borderInput: isDark ? '#2a2d3a' : '#d1d5db',
    border: isDark ? '#1e2130' : '#e5e7eb',
    borderHeader: isDark ? '#2a2d3a' : '#d1d5db',
    text: isDark ? '#e1e4ea' : '#1f2937',
    textMuted: isDark ? '#8b8fa3' : '#6b7280',
    textDim: isDark ? '#4a5568' : '#9ca3af',
    headerBg: isDark ? '#13151e' : '#f9fafb',
    headerText: isDark ? '#8b8fa3' : '#6b7280',
    green: '#22c55e',
    red: '#ef4444',
    yellow: '#fbbf24',
    blue: '#3b82f6',
    purple: '#a78bfa',
  };
}

export function getDensity(density) {
  const rowPad = density === 'compact' ? '3px 6px' : density === 'comfortable' ? '6px 8px' : '4px 6px';
  const fontSize = density === 'compact' ? 11 : density === 'comfortable' ? 12.5 : 11.5;
  return { rowPad, fontSize };
}
